module.exports = __webpack_public_path__ + "media/images/icon/arrow-c333890c3b6ce527a1a114eb30958094.svg";